import { FormikHelpers } from 'formik';
import { t } from 'i18next';

// import { BlockedUserModalBody } from 'components/Modal/BlockedUserModalBody';
// import { showModal } from 'components/MyModal';

import { handleFailToast } from '../toast/handleToast';

export const handleControlAuthError = (error: any, formik?: FormikHelpers<any>, fieldName?: string) => {
  const errorCode = error.response.data.code;

  switch (errorCode) {
    case 'USER_NOT_FOUND':
    case 'NOT_EXIST_USER':
      formik?.setFieldError('username', t('login.userinfo_username_fail_validation_message'));
      return;
    case 'DUPLICATED_USERNAME_OR_EMAIL':
      if (fieldName === 'writername') {
        formik?.setFieldError(fieldName, t('register.userinfo_writername_used_validation_message'));
        return;
      }
      formik?.setFieldError(fieldName ?? 'username', t('profile.edit_username_duplicate_message'));
      return;
    case 'INVALID_CREDENTIAL': // 비밀번호가 등록했으나 잘못된 비밀번호를 입력했을 경우
      formik?.setFieldError('password', t('login.userinfo_password_fail_validation_message'));
      return;
    case 'NO_PASSWORD_YET': // 비밀번호를 등록하지 않은 경우
      formik?.setFieldError('password', t('login.userinfo_password_not_set_validation_message'));
      return;
    // ChangePasswordModal 에서만 사용
    case 'INVALID_CURRENT_PASSWORD':
      formik?.setFieldError('currentPassword', t('setting.edit_password_input_current_password_placeholder'));
      return;
    case 'NEW_PASSWORD_MUST_BE_DIFFERENT':
      formik?.setFieldError('newPassword', t('setting.edit_password_change_new_password_validation_toast'));
      return;
    case 'USER_NOT_VERIFIED': // 안증된 메일이 없는 경우
      formik?.setFieldError('email', t('login.password_reset_password_email_validation_email_none_message'));
      return;
    case 'EMAIL_NOT_MATCH': // 이미 인증된 메일이 있는데, 다른 메일을 입력했을 경우
      formik?.setFieldError('email', t('login.password_reset_password_email_validation_email_verify_message'));
      return;
    case 'EMAIL_ALREADY_VERIFIED': // 이미 인증된 이메일 입력했을 경우
      formik?.setFieldError('email', t('setting.edit_email_verify_email_template_expiration_message'));
      return;
    case 'CURRENT_OWN_EMAIL_ALREADY_VERIFIED':
      formik?.setFieldError('email', t('setting.edit_email_verify_fail_current_text'));
      return;
    case 'USERNAME_ALREADY_RESERVED':
      formik?.setFieldError('username', t('register.userinfo_username_impossible_used_validation_message'));
      return;
    case 'WRITERNAME_ALREADY_RESERVED':
      formik?.setFieldError('writername', t('register.userinfo_writername_impossible_used_validation_message'));
      return;
    // case 'BLOCKED':
    //   showModal({
    //     body: (
    //       <BlockedUserModalBody
    //         isCommunityBlocked={errorCode === 'BLOCKED_COMMUNITY'}
    //         userName={error.data.userName}
    //         writername={error.data.writername}
    //         comment={error.data.comment}
    //         endAt={error.data.endAt}
    //       />
    //     ),
    //     modalWrapStyle: {
    //       maxWidth: 'fit-content',
    //       padding: '0',
    //       borderRadius: '12px',
    //       maxHeight: '80vh',
    //     },
    //     closeOnBackdropClick: false,
    //   });
    //   return;
    default:
      handleFailToast(t('general.contact_customer_support_error_message'));
      return;
  }
};
